import React from 'react';
import styles from './FlatCell.module.scss';
import cn from 'classnames';
import { requestInFlatStagesColorsMap } from '../../../../../../../HousingStock/constants/stagesColorMaps';
import { requestInFlatStatuses } from '../../../../../../../HousingStock/constants/common';
import { Tooltip } from 'antd';
import IndicatorBadge from '../../../../../../../HousingStock/components/common/IndicatorBadge/IndicatorBadge';
import { texts } from '../../../../../../../HousingStock/constants/texts';
import { convertPenniesToRub } from '../../../../../../../../helpers/convertPenniesToRub';

const badgeColors = {
  immediate: requestInFlatStagesColorsMap.get(requestInFlatStatuses.immediate),
  debt: requestInFlatStagesColorsMap.get(requestInFlatStatuses.debt),
  active: requestInFlatStagesColorsMap.get(requestInFlatStatuses.active),
  comment: requestInFlatStagesColorsMap.get(requestInFlatStatuses.comment),
};

const DEFAULT_BG_COLOR = '#efefef';
const DEFAULT_BORDER_COLOR = 'transparent';

const FlatCell = ({
  flatData,
  entranceName,
  onClick,
  isOffice = false,
  bgColor = DEFAULT_BG_COLOR,
  borderColor = DEFAULT_BORDER_COLOR,
  activeFlat,
  ...props
}) => {
  const {
    existDebt,
    immediateRequestCount,
    activeRequestCount,
    amount,
    hasComment,
    floor,
    address,
    addressId,
  } = flatData;

  const handleClick = () => {
    onClick(flatData);
  };

  const hasIndicator = Boolean(
    existDebt || immediateRequestCount || activeRequestCount || hasComment
  );

  const isActiveCell = !!activeFlat && activeFlat?.addressId === addressId;

  return (
    <div
      {...props}
      style={{
        ...props.style,
        backgroundColor: bgColor,
        borderColor: borderColor,
      }}
      className={cn(styles.root, {
        [styles.additionalInfo]: address?.synonym,
        [styles.activeFlat]: !!isActiveCell,
      })}
      onClick={onClick ? handleClick : undefined}
      data-floor={`${floor} этаж`}
    >
      {address?.name || ''}
      {hasIndicator && (
        <div className={styles.indicatorsContainer}>
          {existDebt && (
            <Tooltip
              title={
                amount
                  ? `${texts.debt}: ${convertPenniesToRub(-1 * amount)} руб.`
                  : ''
              }
            >
              <IndicatorBadge
                withBorder
                bgColor={badgeColors.debt}
              />
            </Tooltip>
          )}
          {Boolean(immediateRequestCount) && (
            <IndicatorBadge
              withBorder
              bgColor={badgeColors.immediate}
            />
          )}
          {Boolean(activeRequestCount) && (
            <IndicatorBadge
              withBorder
              bgColor={badgeColors.active}
            />
          )}
          {hasComment && (
            <IndicatorBadge
              withBorder
              bgColor={badgeColors.comment}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default FlatCell;
